import { Box, Typography } from '@mui/material';

import { ATSAutomationCreateTestIds } from 'data-testids/ATS';
import { CreateAutomationProps } from '../types';
import { CreateForm } from './components/CreateForm';

export const CreateAutomation: React.FC<CreateAutomationProps> = ({
  automationState,
  automationDispatch,
}) => {
  return (
    <Box data-testid={ATSAutomationCreateTestIds.CREATE_PANE}>
      <Typography data-testid={ATSAutomationCreateTestIds.APPLY_AUTOMATION_TEXT} sx={{ pb: 1 }}>
        Apply to:
      </Typography>
      <CreateForm automationState={automationState} automationDispatch={automationDispatch} />
    </Box>
  );
};
